module.exports = __SPARKY_LIBS__.ReactIntl;